import css from "./delete_booking_modal.module.scss";

export const OptionLabel = ({ label, startDate, endDate }) => (
  <div className={css.optionLabel}>
    {label} <span>{`${startDate} - ${endDate}`}</span>
  </div>
);
